import React, { ReactNode, useRef, useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import { clstagStr } from '../../utils/util';
import { CLSTAG } from '../../utils/constant';
type DraweProps = {
  defaultOpened: boolean;
  direction: 'left' | 'right';
  width: number | string;
  classNames?: string;
  btnWrapperCls?: string;
  children: ReactNode;
  collapseNode: ReactNode;
  handleCollapse?: (isOpened: boolean) => void;
  handleExpand?: (isOpened: boolean) => void;
};
const Drawer = (props: DraweProps) => {
  const {
    direction,
    width,
    classNames,
    collapseNode,
    defaultOpened,
    btnWrapperCls,
    handleCollapse,
    handleExpand,
  } = props;
  const suspendedRef = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  const handleClickCollapseBtn = () => {
    drawerRef.current && (drawerRef.current!.style.width = '0px');
    setTimeout(() => {
      handleCollapse && handleCollapse(false);
      suspendedRef.current && (suspendedRef.current!.style.display = 'block');
    }, 300);
  };

  const handleClickExpand = () => {
    suspendedRef.current && (suspendedRef.current!.style.display = 'none');
    drawerRef.current &&
      (drawerRef.current!.style.width =
        typeof width === 'string' ? width : `${width}px`);
    handleExpand && handleExpand(true);
  };

  return (
    <>
      <div
        ref={drawerRef}
        className={classnames('drawer-wrapper', {
          [classNames || '']: true,
        })}
        style={{ width: defaultOpened ? width : 0 }}
      >
        {direction === 'left' && (
          <i
            className='left-collapse-btn'
            onClick={handleClickCollapseBtn}
            clstag={clstagStr(CLSTAG.LeftDrawerOpenClose)}
          />
        )}
        {props.children}
        {direction === 'right' && <i className='right-collapse-btn'></i>}
      </div>
      <div
        className={classnames('suspended-btn-area', {
          [btnWrapperCls || '']: true,
        })}
        ref={suspendedRef}
        onClick={handleClickExpand}
      >
        {collapseNode}
        <div
          className='expand-icon'
          clstag={
            direction === 'left'
              ? clstagStr(CLSTAG.LeftDrawerOpenClose)
              : clstagStr(CLSTAG.WorkOrderDrawerOpenClose)
          }
        >
          <i></i>
        </div>
      </div>
    </>
  );
};

export default React.memo(Drawer);
